import React from "react";

import {
  MustUpgradePassMessageModal,
  MustUpgradePassMessageModalProps
} from "../../MustUpgradePassMessage";

export type Props = Omit<MustUpgradePassMessageModalProps, "message">;

export default function ExpiredSubscriptionForCourseMessage(props: Props) {
  return (
    <MustUpgradePassMessageModal
      {...props}
      message={`Your package has expired. You need to renew it to access this course.`}
    />
  );
}
